import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { AlineacionImagenEnum } from "@componentes/Enums.enum";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { ConsultaAcuerdoAcuerdoComponent } from "./seccion/consultaacuerdo_acuerdo.component";
import { _MatTabGroupBase } from "@angular/material/tabs";
import { ConsultaAcuerdoGeneralComponent } from "./seccion/consultaacuerdo_general.component";
import { ConsultaAcuerdoPadreComponent } from "./seccion/consultaacuerdo_padre.component";
import { ConsultaAcuerdoAlumnoComponent } from "./seccion/consultaacuerdo_alumno.component";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";


@Component(
    {
        selector: 'consultaacuerdodetalle',
        templateUrl: './consultaacuerdodetalle.component.html',
        styleUrls: ['./consultaacuerdo.component.scss']
    })

export class ConsultaAcuerdoDetalleComponent implements AfterViewInit{
  @Input() entidad!: any;
  @Input() accion!: {accionid: number, accion: string};
  @Output() output = new EventEmitter();
  consulta!: boolean;
  abierto2!: boolean;

  public animacion!: string;

  @ViewChild('tab') private tab!: _MatTabGroupBase;

  handleTabClick:any

  listapuestoacuerdo: any[] = [];

  departamentoagrupado: string = "";
  puestoagrupado: string = "";
  nivelagrupado: string = "";

  selectedTabIndex = 0;

  vergrupo: boolean = false;

  @ViewChild('acuerdo') private acuerdo!: ConsultaAcuerdoAcuerdoComponent;
  @ViewChild('general') private general!: ConsultaAcuerdoGeneralComponent;
  @ViewChild('padre') private padre!: ConsultaAcuerdoPadreComponent;
  @ViewChild('alumno') private alumno!: ConsultaAcuerdoAlumnoComponent;

  public AlineacionImagenEnum = AlineacionImagenEnum;
  constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
      if(this.entidad.asignacionacuerdoresponsableid){
        this.vergrupo = true;
        this.listaagrupado();
      }
    }

    Salir(){
      this.output.next(true);
    }

    Generarpdf(){

      let general = {};
      switch (this.selectedTabIndex) {
          case 0:
            if(this.acuerdo.entidadacuerdoactual.firmado){
              this.appService.PostGetFile("acuerdo/generarpdf", this.entidad).then(res=> {
                if(res.status == RespuestaEstatusEnum.Success){

                }
            })
            }else{
              this.mensajeService.Alerta(AlertaEnum.Warning,"No se puede generar PDF hasta que el acuerdo sea firmado por ambas partes")
            }
            break;
          case 1:
              if(this.general.entidad.otropuesto){
                if(this.general.puesto){
                  general = {"general": this.general.entidad, "periodo":this.general.periodo, "visualizacion": this.general.tipovisualizacion, "seleccionreporte": 1, "puestolocal": this.general.puestolocal};
                }else{
                  this.mensajeService.Alerta(AlertaEnum.Warning, "Para descargar el reporte es necesario seleccionar un Puesto");
                }
              }else{
                general = {"general": this.general.entidad, "periodo":this.general.periodo, "visualizacion": this.general.tipovisualizacion, "seleccionreporte": 1, "puestolocal": this.general.puestolocal};
              }
              break;
          case 2:
              if(this.alumno.entidad.otropuesto){
                if(this.alumno.puesto){
                  general = {"alumno": this.alumno.entidad, "periodo":this.alumno.periodo, "visualizacion": this.alumno.visual, "seleccionreporte": 2, "grupo": this.alumno.grupo, "materia": this.alumno.materia, "puestolocal": this.alumno.puestolocal};
                }else{
                  this.mensajeService.Alerta(AlertaEnum.Warning, "Para descargar el reporte es necesario seleccionar un Puesto");
                }
              }else{
                general = {"alumno": this.alumno.entidad, "periodo":this.alumno.periodo, "visualizacion": this.alumno.visual, "seleccionreporte": 2, "grupo": this.alumno.grupo, "materia": this.alumno.materia, "puestolocal": this.alumno.puestolocal};
              }
              break;
          case 3:
              if(this.padre.entidad.otropuesto){
                if(this.padre.puesto){
                  general = {"padre": this.padre.entidad, "periodo":this.padre.periodo, "visualizacion": this.padre.visual, "seleccionreporte": 3, "grupo": this.padre.grupo, "materia": this.padre.materia, "puestolocal": this.padre.puestolocal};
                }else{
                  this.mensajeService.Alerta(AlertaEnum.Warning, "Para descargar el reporte es necesario seleccionar un Puesto");
                }
              }else{
                general = {"padre": this.padre.entidad, "periodo":this.padre.periodo, "visualizacion": this.padre.visual, "seleccionreporte": 3, "grupo": this.padre.grupo, "materia": this.padre.materia, "puestolocal": this.padre.puestolocal};
              }
              break;
      }
      if(Object.keys(general).length === 0){
        return;
      }
      this.appService.PostGetFile("reporte/evaluacion/generarpdf", general).then(res=> {
          if(res.status == RespuestaEstatusEnum.Success){

          }
      })
    }

    listaagrupado(){
      this.appService.Post("acuerdo/listaacuerdo",{"entidad": this.entidad}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.listapuestoacuerdo = res.data;
          this.departamentoagrupado = this.listapuestoacuerdo.map(dep=> dep.departamentosub).join("<br />");
          this.puestoagrupado = this.listapuestoacuerdo.map(pue=> pue.puestosub).join("<br />");
          this.nivelagrupado = this.listapuestoacuerdo.map(ni=> ni.nivel).join("<br />");
        }
      })
    }

    ModalInternotabla(){
      this.animacion = this.sistemaService.animacionAbirModal;
      this.abierto2 = true;
    }

    CerrarModalInternotabla(){
      this.animacion = this.sistemaService.animacionCerrarModal;
      setTimeout(() => {
          this.abierto2 = false;
      }, 310);
    }

    yourFn(){
      switch (this.selectedTabIndex) {
        case 0:
            break;
        case 1:
            if(this.general.listageneral.length == 0){
              if(!this.entidad.asignacionacuerdoresponsableid){
                this.general.puestolocal = this.entidad.puestosubid;
                this.general.CargarInfo(1)
              }else{
                this.general.listapuesto = this.listapuestoacuerdo;
                this.general.puesto = this.entidad.puestosubid;
                this.general.puestolocal = this.entidad.puestosubid;
                this.general.CargarInfo(1)
              }
            }
            break;
        case 2:
            if(this.alumno.listageneral.length == 0){
              if(!this.entidad.asignacionacuerdoresponsableid){
                this.alumno.getmateria();
                this.alumno.CargarInfo(1)
              }else{
                this.alumno.listapuesto = this.listapuestoacuerdo;
                this.alumno.puesto = this.entidad.puestosubid;
                this.alumno.getmateria();
                this.alumno.CargarInfo(1)
              }
            }
            break;
        case 3:
          if(this.padre.listageneral.length == 0){
            if(!this.entidad.asignacionacuerdoresponsableid){
              this.padre.getmateria();
              this.padre.CargarInfo(1)
            }else{
              this.padre.listapuesto = this.listapuestoacuerdo;
              this.padre.puesto = this.entidad.puestosubid;
              this.padre.getmateria();
              this.padre.CargarInfo(1)
            }
          }
          break;
      }
    }
  }
